import axios from "axios"

axios.defaults.headers.common["Content-Type"] = "application/json"
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const makeRequestCreator = () => {
  let call
  return (url) => {
    if (call) {
      call.cancel("Only one request allowed at a time.")
    }
    call = axios.CancelToken.source()
    return axios.get(url, {
      cancelToken: call.token,
    })
  }
}

const getRequest = makeRequestCreator()

const get = async (url) => {
  try {
    return await getRequest(url)
  } catch (err) {
    if (axios.isCancel(err)) {
      // console.error(`Cancelling previous request: ${err.message}`);
    }
  }
}

export default {
  get: get,
}
